import { getMomentTz, MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { Event } from "../models/Event";

const moment = getMomentTz();

// Read-only wrapper over the mill calendar: [FAB].[GetMillEvents] pins Mill 2
// and DraftMode = 0 server-side.
export const getMillEvents = async (
	params: {
		start?: Date;
		end?: Date;
		eventId?: number;
		monthStart?: Date | null;
		dayBreakdown?: boolean;
	},
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "Start", value: params.start?.toISOString() ?? null },
		{ name: "End", value: params.end?.toISOString() ?? null },
		{ name: "DailyBreakdown", value: params.dayBreakdown || false },
		{ name: "EventId", value: params.eventId ?? null },
		{
			name: "MonthStart",
			value: params.monthStart
				? moment(params.monthStart).format("YYYY-MM-DD")
				: null,
		},
	];

	const resp = await apiService.callV2(
		"[FAB].[GetMillEvents]",
		parameters,
		signal,
	);

	if (resp.ok) {
		let rows = get(resp, "data.tables[0].rows", []);

		rows = rows.map((e: Event) => ({
			...e,
			Start: moment.utc(e["Start"]).toDate(),
			End: e.End ? moment.utc(e["End"]).toDate() : null,
			CreatedAt: moment.utc(e["CreatedAt"]).toDate(),
			Deadline: e.Deadline ? moment.utc(e["Deadline"]).toDate() : null,
			InquiryCloseDate: e.InquiryCloseDate
				? moment.utc(e["InquiryCloseDate"]).toDate()
				: null,
			UpdatedAt: e.UpdatedAt ? moment.utc(e["UpdatedAt"]).toDate() : null,
			ScheduledMillYield: e.ScheduledMillYield ?? 0,
			ScheduledFinishedYield: e.ScheduledFinishedYield ?? 0,
			ActualMillYield: e.ActualMillYield ?? 0,
			ActualFinishedYield: e.ActualFinishedYield ?? 0,
		}));

		rows.sort((a: Event, b: Event) => a.Start.getTime() - b.Start.getTime());

		const lastMatchedId =
			rows.filter((e: Event) => e.IsMatched).at(-1)?.EventId ?? null;

		rows = rows.map((e: Event, index: number) => ({
			...e,
			IsLastMatched: e.IsMatched && e.EventId === lastMatchedId,
			PreviousSection: index > 0 ? rows[index - 1].SectionName : null,
			PreviousEnd: index > 0 ? rows[index - 1].End : null,
			NextStart: index < rows.length - 1 ? rows[index + 1].Start : null,
			NextSection: index < rows.length - 1 ? rows[index + 1].SectionName : null,
		}));

		return rows as Event[];
	} else {
		throw new Error(resp.message || "Error fetching mill events");
	}
};
